import rawCommands from "./commands.json";

export const COMMANDS = rawCommands;

const counts = COMMANDS.reduce((acc, cmd) => {
  acc[cmd.category] = (acc[cmd.category] || 0) + 1;
  return acc;
}, {});

export const COMMAND_CATEGORIES = [
  "All",
  ...Object.entries(counts)
    .sort((a, b) => b[1] - a[1])
    .map(([name]) => name),
];
